import { Identifiable } from "./identifiable";
import { id } from "./id";
import { Project, project } from "./project";
import { Role, role } from "./role";
import { Resource, resource } from "./resource";

type ProjectResource = {
  project: Identifiable<Project>;
  role: Identifiable<Role>;
  resource: Identifiable<Resource>;
  deactivated: boolean;
};

const projectResource: ProjectResource = {
  project: { ...project, uuid: id },
  resource: { ...resource, uuid: id },
  role: { ...role, uuid: id },
  deactivated: false,
};

export type { ProjectResource };

export { projectResource };
